import React from 'react';
import './TimerBar.css';

const TimerBar = ({ duration, isRunning, resetKey }) => {
    return (
        <div className="timer-bar-container">
            <div 
                key={resetKey} // Reset animation when key changes
                className="timer-bar-fill"
                style={{
                    animationDuration: `${duration}s`,
                    animationPlayState: isRunning ? 'running' : 'paused'
                }}
            />
        </div>
    );
};

export default TimerBar;